import { ControlType, Property, PropertyType } from "../../../base/types";

import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const VideoComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const url: string | undefined = properties[Property.Url];
    const altText: string | undefined = properties[Property.AltText];
    const tooltip: string | undefined = properties[Property.Tooltip];

    return (
        <video className={className} controls title={tooltip}>
            <source src={url} />
            {altText || 'Your browser does not support the video tag.'}
        </video>
    )
}

Registry.addControl({
    id: "52f1a506-d798-43be-a80f-f868ad5d1d55",
    name: "Video",
    type: ControlType.Video,
    properties: [
        { id: Property.AltText, name: 'Alternate text', type: PropertyType.String },
        { id: Property.Url, name: 'Url', type: PropertyType.String },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: VideoComponent
})
